import { memo } from 'react';
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import { useParams, useNavigate } from 'react-router-dom';
// Local files
import { StyledListItemButton, ItemTitle, ItemTimestamp } from './Item.styled';
import BaseAvatar from 'components/Common/BaseAvatar/BaseAvatar';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import usePatients from 'hooks/usePatients';
import useConversations from 'hooks/useConversations';
import useMessages from 'hooks/useMessages';
import useCustomSelector from 'hooks/useCustomSelector';
import { patientsSelectors } from 'features/patients';
import { messagesSelectors } from 'features/messages';
import { conversationsSelectors } from 'features/conversations';

const Item = ({ id, title, timestamp, userable }) => {
  const { patient_id } = useParams();
  const navigate = useNavigate();
  const { clearLocalConversations, clearLocalActiveConversation } = useConversations();
  const { clearLocalMessages } = useMessages();
  const { clearLocalActivePatient } = usePatients();
  const patientFetching = useCustomSelector(patientsSelectors.patientIsFetching);
  const messagesFetching = useCustomSelector(messagesSelectors.messagesIsFetching);
  const conversationsFetching = useCustomSelector(conversationsSelectors.isFetchingConversations);
  const fetching = patientFetching || messagesFetching || conversationsFetching;

  const handleSelectPatient = (e) => { 
    e.stopPropagation();
    if (!fetching && id !== patient_id) {
      clearLocalActivePatient();
      clearLocalActiveConversation();
      clearLocalConversations();
      clearLocalMessages();
      navigate(`/patients/${id}`);
    }
  };

  return (
    <ListItem disablePadding>
      <StyledListItemButton id={`chat-${patient_id}`} selected={id === patient_id} onClick={handleSelectPatient}>
        <BaseAvatar userable={userable} src={null} />
        <Box sx={{ flexGrow: 1 }}>
          <ItemTitle>{title}</ItemTitle>
        </Box>
        <ItemTimestamp>{timestamp}</ItemTimestamp>
      </StyledListItemButton>
    </ListItem>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <Item {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);